import { Organization, OrganizationService } from '@/api/';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';
import { useStore } from '@nanostores/react';
import { useQuery } from '@tanstack/react-query';

/**
 * We'll update the selected organization in the store and route
 * to the workspaces for this organization.
 * @param org The organization that the user selected
 */
function handleSelectOrg(org: Organization) {
  $org.set(org);
  openPage($router, 'workspaces', { organizationId: org.id });
}

export const OrganizationListing = () => {
  // const orgs = useStore($orgs);

  // get orgs query
  const orgs = useQuery({
    queryKey: ['getOrganizations'],
    queryFn: async () => {
      const res = await OrganizationService.getOrganizations();
      return res;
    },
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });

  const selectedOrg = useStore($org);

  useEffect(() => {
    if (orgs?.isSuccess) {
      if (orgs?.data?.length > 0) {
        $orgs.set(orgs?.data);
      }
    }
  }, []);

  return (
    <>
      <ScrollArea className="max-h-[calc(100vh-[190px])]">
        <div className="flex flex-col gap-3">
          {orgs.isLoading && <div>Loading...</div>}
          {orgs.data?.map(org => (
            <button
              key={org.id}
              className={cn(
                'flex flex-col items-start gap-2 rounded-lg border p-4 text-left text-sm transition-all hover:bg-accent',
                selectedOrg?.id === org.id && 'bg-muted',
              )}
              onClick={() => handleSelectOrg(org)}
            >
              <div className="flex w-full items-center gap-4">
                <Avatar className="h-10 w-10">
                  <AvatarImage src={org.logoUrl || ''} />
                  <AvatarFallback>
                    {org.name.slice(0, 2).toLocaleUpperCase()}
                  </AvatarFallback>
                </Avatar>

                <div className="flex w-full flex-col gap-1">
                  <div className="flex items-center">
                    <div className="flex items-center gap-2">
                      <div className="text-sm font-semibold">{org.name}</div>
                    </div>
                    <div
                      className={cn(
                        'ml-auto text-sm',
                        selectedOrg?.id === org.id
                          ? 'text-foreground'
                          : 'text-muted-foreground',
                      )}
                    >
                      {new Date(org.createdAtUtc).toLocaleDateString()}
                    </div>
                  </div>
                  {org.createdBy && (
                    <div className="">Created by: {org.createdBy.name}</div>
                  )}
                </div>
              </div>
            </button>
          ))}
        </div>
      </ScrollArea>
    </>
  );
};
